// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "socialcam-frontend/js/" + chunkId + "." + "4a0e6a84" + ".js";
};